import styled, { css } from 'styled-components';
import { palette } from 'styled-tools';

import { SignupScreensKey } from '@/components/b2b/shared/types';

const fullscreenCss = css`
	bottom: 0;
	left: 0;
	right: 0;
	position: absolute;
	top: 0;
`;

const BACKGROUND_BREAK = 50;

export const BackgroundWrapper = styled.div`
	${fullscreenCss}
	z-index: -1;
	min-width: 100%;
	min-height: 100%;
	position: fixed;
`;

export const BackgroundImageWrapper = styled.div`
	position: relative;
	height: ${BACKGROUND_BREAK + 10}%;
`;

export const GradientOverlay = styled.div`
	${fullscreenCss}
	background: linear-gradient(
      180deg,
      rgba(67, 117, 159, 0.85) 0%,
      rgba(47, 50, 123, 1) ${BACKGROUND_BREAK}%
    );
`;

export const DimmingOverlay = styled.div`
	${fullscreenCss}
	background: rgba(0, 0, 0, 0.64);
`;

export const Container = styled.div`
	height: 100%;
	min-height: 100vh;
	color: ${palette('white')};
`;

export const InnerContainer = styled.div<{
	activeScreen?: SignupScreensKey | null;
}>`
	max-width: 400px;
	margin: auto;
	padding: 6rem 1rem;
`;
